import { linkTransitionDuration } from '../../css/utils/variables_misc.scss'
import getFocusTrapEventHandler from './focus_trap'

up.compiler('.js-mobile_menu', function (mobileMenuWrapper) {
  const { onFocus, focusFirst } = getFocusTrapEventHandler(mobileMenuWrapper)
  const hamburgerMenu = new MobileHamburgerMenu(mobileMenuWrapper, onFocus, focusFirst)

  return function () {
    hamburgerMenu.close()
  }
})

class MobileHamburgerMenu {
  constructor(mobileMenuWrapper, onFocus, focusFirst) {
    this.mobileMenuWrapper = mobileMenuWrapper
    this.mobileMenuOpenButton = document.querySelector('.js-open_mobile_menu')
    this.mobileMenuCloseButtons = Array.from(document.querySelectorAll('.js-close_mobile_menu'))
    this.links = Array.from(this.mobileMenuWrapper.querySelectorAll('a'))
    this.onFocus = onFocus
    this.focusFirst = focusFirst
    this.attachEventListener()
  }

  open() {
    this.mobileMenuWrapper.style.display = 'block'

    window.setTimeout(() => {
      document.body.classList.add('no_scrolling_on_mobile')
      this.mobileMenuWrapper.classList.add('open')
      this.mobileMenuOpenButton.setAttribute('aria-expanded', 'true')
      this.mobileMenuWrapper.setAttribute('aria-hidden', 'false')
      this.mobileMenuWrapper.addEventListener('keydown', this.onFocus)
      this.focusFirst()
    }, 1)
  }

  close() {
    document.body.classList.remove('no_scrolling_on_mobile')
    this.mobileMenuWrapper.classList.remove('open')
    this.mobileMenuOpenButton.setAttribute('aria-expanded', 'false')
    this.mobileMenuWrapper.setAttribute('aria-hidden', 'true')
    this.mobileMenuWrapper.removeEventListener('keydown', this.onFocus)

    window.setTimeout(() => {
      this.mobileMenuWrapper.style.display = 'none'
    }, parseInt(linkTransitionDuration))
  }

  attachEventListener() {
    this.mobileMenuOpenButton.addEventListener('click', this.open.bind(this), false)
    this.mobileMenuCloseButtons.forEach(button => button.addEventListener('click', this.close.bind(this), false))
    this.links.forEach(link => link.addEventListener('click', this.open.bind(this), false))
  }
}
